module.exports = __webpack_public_path__ + "static/img/bg-1.71c147c6.webp";